import React from 'react'
import PropTypes from 'prop-types'

import GoogleMediaFilesPreview from '../../../../GoogleMediaFilesPreview'

import { getPortraitImageData } from '../HeadlinesSection/helpers'

const PortraitImageSectionPreview = ({ data }) => {
  const { assets } = data
  const portraitImageData = getPortraitImageData(assets)

  return <GoogleMediaFilesPreview assets={portraitImageData} />
}

PortraitImageSectionPreview.propTypes = {
  data: PropTypes.object
}

export default PortraitImageSectionPreview
